// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function box6_click(event) {
	//Add your code for this event here: 
}

export function box6_click_1(event) {
	//Add your code for this event here: 
}